const English = [
	"A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"
]

// 单选多选默认四组
const options = [
	{
		name:'selectNmae',
		selectval:'selectval',
	},
	{
		name:'selectNmae',
		selectval:'selectval',
	},
	{
		name:'selectNmae',
		selectval:'selectval',
	},
	{
		name:'selectNmae',
		selectval:'selectval',
	}
]
const materials = [
	{
		name:'content',
		contentval:'contentval',
		sonName:'sonName',
		sonVal:'sonVal',
	}
]



export default {
	options,
	English,
	materials
}


// WEBPACK FOOTER //
// ./src/assets/js/public.js